import {
  Container,
  Title,
  Heading,
  CardContainer,
  Card,
  CardTitle,
  CardText,
  InnerContainer,
  CardOverlay,
  CardOverlayTitle,
  CardOverlayText,
  CardOverlayPicture,
  CardOverlayInnerContainer,
  StyledButton
} from './WhyRoundPE.style';
import WhyRoundPEOverlayPicture from '../../../assets/images/WhyRoundPEOverlayPicture.webp';
import { RightIcon } from '../../../assets/svg';

export const WhyRoundPESection = () => {
  return (
    <>
      <Container>
        <InnerContainer>
          <Title>Why RoundPe</Title>
          <Heading>
            Created by engineers and founders, we built RoundPe from the ground
            up to solve our own problem
          </Heading>
          <CardContainer>
            <Card>
              <CardTitle>Supporting fast and low-cost networks</CardTitle>
              <CardText>
                No need to turn away a user due to high transaction fees and
                lack of support for a particular network. RoundPe supports all
                major fast and low-cost networks.
              </CardText>
            </Card>
            <Card>
              <CardTitle>Pay from any wallet</CardTitle>
              <CardText>
                Users can now pay from anywhere - Be it Coinbase wallet, Binance
                exchange, Metamask, Ledger etc. Users don&apos;t need to worry
                if their wallet is supported or not
              </CardText>
            </Card>
            <Card>
              <CardTitle>Easy Integration</CardTitle>
              <CardText>
                Accept your first payment with RoundPe in minutes. With an easy
                to use dashboard and detailed analytics, accepting and managing
                payments is now a breeze.
              </CardText>
            </Card>
          </CardContainer>
        </InnerContainer>
      </Container>
      <CardOverlay>
        <CardOverlayInnerContainer>
          <CardOverlayTitle>
            Join hundreds of users who are doing more with RoundPe.
          </CardOverlayTitle>
          <CardOverlayText>
            {/* &quot;I saw immediate results. I got quick payments in realtime in
            my account in multiple currencies.&quot; - Fabrizio Rinaldi */}
          </CardOverlayText>
          <StyledButton
            target="_blank"
            rel="noreferrer"
            href={process.env.REACT_APP_DASHBOARD_URL}
          >
            Get Started
            <RightIcon />
          </StyledButton>
        </CardOverlayInnerContainer>
        <CardOverlayPicture src={WhyRoundPEOverlayPicture}></CardOverlayPicture>
      </CardOverlay>
    </>
  );
};
